module.exports = "/images/side-delete-project.svg?494f54aadd1f61df14b88606aa6d12e0";